export default "__VITE_ASSET__CAqagjjU__"